import React, { useState } from 'react';
import Header from './components/Header';
import * as Images from '../assets';
import { Box, Grid, Modal } from '@mui/material';
import { LightBlueButton } from '../components';
import { Close } from '@mui/icons-material';

const AboutPage = () => {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  return (
    <div>
      {/* <Header page="about" /> */}
      <div
        className="md:px-8 px-2 md:py-16 py-8 flex justify-center "
        style={{
          backgroundImage: `url('${Images.homePage8}')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          transition:
            'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
        }}
      >
        <div className="lg:w-[80%] md:w-[95%] w-[100%]">
          <div className="lg:px-12 md:px-8 px-6 py-10">
            <div className="flex flex-col gap-12 items-center">
              <div className="flex flex-col gap-2 items-center">
                <div className="text-[var(--blue)] font-bold text-md uppercase tracking-[3px]">
                  About Aid-LINK
                </div>
                <div className="divider" />
                <div className="text-md text-center">
                  Welcome to Aid-LINK, the world’s best tender notice board and
                  alert service, with supplier members and humanitarian partners
                  world-wide.
                </div>
              </div>
              <div className="lg:text-6xl md:text-4xl text-2xl font-bold">
                Why choose us?
              </div>
              <div className="space-y-4">
                <div>
                  <div className="font-bold text-center">Vision</div>
                  <div className="text-center">
                    Create business opportunities for every member of our global
                    platform.
                  </div>
                </div>

                <div>
                  <div className="font-bold text-center">Our mission</div>
                  <div className="text-center">
                    The mission of Aid-LINK is simple: connect the humanitarian
                    organisation to suppliers to make both parties more
                    effective and successful.
                  </div>
                </div>

                <div>
                  <div className="font-bold text-center">Who are we?</div>
                  <div className="text-center">
                    Aid-LINK began life as TenderNoticeBoard.com in 2019 founded
                    by co-founder Michael Hasselstroem and were officially
                    launched as Aid-LINK.com on January 15, 2025.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Grid container spacing={3} className="md:px-8 px-4">
            <Grid item md={4} xs={12}>
              <div className="flex flex-col gap-6 text-sm">
                <div className="leading-[2]">
                  Aid-LINK was originally founded by a veteran of the
                  humanitarian procurement and supply chain landscape as
                  tendernoticeboard.com in 2019. The company now consists of a
                  strong experienced team with expertise in humanitarian
                  emergency operations and long-term development around the
                  globe with UN agencies, INGO’s and Governments. We aim to
                  improve the way humanitarian organisations and agencies source
                  and negotiate for goods, works and services around the world
                  to maximise the impact of foreign aid and enhance the quality
                  and quantity of assistance to those that need it.
                </div>
                <div className="leading-[2]">
                  We partner with organisations and agencies to help address
                  their procurement challenges through our technological
                  expertise and operational knowledge of complex humanitarian
                  and development operations and procurement procedures. Our
                  Aid-LINK platform is tailored specifically for humanitarian
                  organisations and agencies and their suppliers to support the
                  automation of manual procurement processes.
                </div>
              </div>
            </Grid>
            <Grid item md={4} xs={12}>
              <div className="flex flex-col gap-6 text-sm">
                <div className="leading-[2]">
                  At Aid-LINK, we believe the path to equality begins with
                  transparency and accessibility to all business opportunities
                  in the humanitarian sector and our commitment to make the
                  world a better place.
                </div>
                <div className="leading-[2]">
                  Our co-founder &amp; managing director Michael Hasselstroem
                  develops our business vision, ethics and is working on
                  expanding the company’s tech and global footprint. He has 22
                  years of experience in humanitarian supply chain and 11 years
                  experience in the procurement and sourcing software space.
                </div>
                <div className="leading-[2]">
                  Michael has held management roles in technology and supply
                  chain companies, additional he worked in United Nations World
                  Food Programme, United Nations Population Fund, Danish
                  Demining Group and Danish Refugee Council. In 2013 he founded
                  and remain managing director of Global eSourcing, a SaaS based
                  global provider of procurement management solution serving
                  organisation in the humanitarian sector.
                </div>

                <div>
                  <LightBlueButton
                    onClick={handleOpen}
                    size="large"
                    sx={{ fontSize: '12px' }}
                  >
                    FOUNDERS LETTER
                  </LightBlueButton>
                </div>
              </div>
            </Grid>
            <Grid item md={4} xs={12}>
              <div
                className="h-full w-full min-h-96 border-red-500 border-3"
                style={{
                  backgroundImage: `url('${Images.owner}')`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  backgroundSize: '100%',
                  transition:
                    'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
                }}
              />
            </Grid>
          </Grid>
        </div>
      </div>
      <Modal
        open={open}
        aria-labelledby="founders-letter"
        aria-describedby="founders-letter-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { lg: '1000px', md: '700px', sm: '400px', xs: '320px' },
            bgcolor: 'background.paper',
            border: '1px solid var(--dark-blue)',
            backgroundImage: `url('${Images.homePage8}')`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            backgroundSize: 'cover',
            transition:
              'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
          }}
        >
          <div
            style={{
              position: 'relative',
              height: '100vh',
              overflowY: 'auto',
              overflowY: 'auto',
            }}
            className="lg:px-20 md:px-12 px-4 md:py-6 py-4 mb-4"
          >
            <div
              style={{ position: 'sticky', top: 0, left: 0 }}
              className="flex justify-end"
            >
              <Close
                onClick={handleClose}
                className="text-[var(--dark-blue)] hover:text-[var(--dark-blue)] cursor-pointer"
              />
            </div>
            <div className="flex items-center justify-center flex-col gap-4">
              <img alt="logo" style={{ width: '200px' }} src={Images.AppLogo} />
              <div className="text-md">
                A note from Michael, our founder & managing director
              </div>
            </div>
            <div className="flex flex-col gap-4 text-md mt-6">
              <div className="text-center">Hi there…</div>
              <div className="text-center">
                A lot of people ask me why we bothered to build the Aid-LINK.
              </div>
              <div>
                There is an overwhelming number of options out there for finding
                tender notifications and ways to publish tender notices. So,
                it’s a fair question. However, the problem was that none of the
                options were right for me in my work as head of supply chain and
                procurement in humanitarian organisations working in emergencies
                and development projects globally. Nor did they work for me as a
                supplier trying to identify all business opportunities right for
                my business in the humanitarian sector.
              </div>
              <div>
                My company were using Google, Yahoo or Bing searching every
                organisational homepage to find new business opportunities in
                the humanitarian sector, and we were struggling. Search engines
                and organisational platforms isn’t built for the humanitarian
                sector. Finding reliable information and quality business
                opportunities is complex and time consuming and tracking
                performance of both was a huge burden. A ton of tender
                notifications and information was slipping through the cracks.
                The donors, humanitarian organisations and governments weren’t
                happy not getting the response they expected when publishing
                tenders, and neither were we and other suppliers, missing them.
              </div>
              <div>So, I looked for a simpler and better solution.</div>
              <div>
                That’s why I started the Aid-LINK. We developed and built the
                Aid-LINK as a simple tool for the buyer and their suppliers with
                the features anyone needs and can use, and we left out
                everything else. No complexity or extra features to confuse and
                overwhelm you. Just all global humanitarian tender notices in
                one easy to access platform.
              </div>
              <div>
                New features are constantly being developed in coordination with
                suppliers, humanitarian organisations and staff on the ground
                with the aim at keeping Aid-LINK free for humanitarians but
                loaded with features required in day-to-day procurement
                operations. We have just integrated a daily email alert
                notification service based on newest business opportunities in
                the areas of a specific focus within the humanitarian sector, so
                you as a supplier get all relevant information and tender
                notices daily, directly into your mailbox or on your mobile
                phone. Simply subscribe and forget it!
              </div>
              <div>
                I’m proud to say that Aid-LINK is becoming the platform that I
                wish existed back when I was looking for reliable suppliers and
                good quality products and services in many of the world’s
                emergencies and happy to say that as a supplier, I now have
                access to the business opportunities out there with a few
                clicks.
              </div>
              <div>
                I hope you’ll give the Aid-LINK a try and realise it is the best
                business decision you will do this year simply measure by the
                sheer amount of cost and time saved by your staff identifying
                business opportunities in the humanitarian sector, a market that
                often lacks transparency and easy access. I’m confident that it
                will make your life easier, and you and your staff will love it.
              </div>
              <div>
                Give it a try and email me to let me know what you think and if
                you have a suggestion to changes or new features you would like
                to see on the platform in the future.
              </div>

              <div>
                Michael Hasselstroem
                <br />
                Managing director & founder
              </div>
              <div className="flex justify-center">
                <LightBlueButton onClick={handleClose}>Close</LightBlueButton>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default AboutPage;
